import { motion } from "framer-motion";
import { Clock, SunHorizon, Sparkle, Coffee } from "@phosphor-icons/react";
import { PageHeader } from "../components/PageHeader";
import { Schedule } from "../components/Schedule";

const tips = [
    { icon: SunHorizon, title: "Mornings by design", body: "Streams kick off at 11 AM EST and run as long as chat keeps cooking." },
    { icon: Coffee, title: "Sundays are off", body: "Recovery day. Touch grass. Get coffee. Be back Monday." },
    { icon: Sparkle, title: "Wednesday is yours", body: "Subs and chat pick the game. Polls go live in the Discord." },
];

export const SchedulePage = () => {
    return (
        <div data-testid="schedule-page">
            <PageHeader
                eyebrow="Stream Schedule"
                title="Where to find me,"
                accent="every day."
                intro="Seven days, six streams, one absurd amount of daytime chaos. Set a reminder so you don't miss the good ones."
                breadcrumbs={[{ label: "Home", href: "/" }, { label: "Schedule" }]}
            />
            <Schedule />

            <section className="relative py-10 lg:py-14">
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        {tips.map((t, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: i * 0.07 }}
                                className="rounded-2xl border border-white/10 bg-obsidian-900/60 p-6 card-tilt"
                                data-testid={`schedule-tip-${i}`}
                            >
                                <div className="h-10 w-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center mb-4">
                                    <t.icon size={16} weight="fill" className="text-brand-cyan" />
                                </div>
                                <div className="font-display text-base text-white mb-2">{t.title}</div>
                                <div className="text-sm text-white/55">{t.body}</div>
                            </motion.div>
                        ))}
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="mt-6 rounded-2xl border border-white/10 bg-obsidian-900/60 p-6 flex flex-col md:flex-row items-start md:items-center gap-5"
                        data-testid="schedule-tz-card"
                    >
                        <div className="h-12 w-12 rounded-xl bg-brand-cyan/10 border border-brand-cyan/30 flex items-center justify-center">
                            <Clock size={20} className="text-brand-cyan" weight="bold" />
                        </div>
                        <div className="flex-1">
                            <div className="eyebrow text-brand-cyan">Heads up</div>
                            <div className="font-display text-lg text-white mt-1">All times are in EST · GMT-5</div>
                            <p className="text-white/55 text-sm mt-2 max-w-2xl">
                                Convert to your timezone before pulling up — nothing's worse than showing up at 11 AM your time wondering why no one's online.
                            </p>
                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};
